export default {
    createaccount_form: "สร้าง Account",
    redemption: "รับ ",
    redemption_reward: "แลก ",
    collection: "รับ ",
    _items: "รายการ",
    hello: "สวัสดีคุณ,",
    _points: "คะแนน",
    term_and_conditions_shop: " ข้อตกลง & เงื่อนไข",
    need_update_info: "คุณต้องอัปเดทข้อมลส่วนตัวของคุณ!",
    free_point: "Free point",
    accept: "ยอมรับ",
    decline: "ไม่ยอมรับ",
    _terms_and_conditions: " ข้อตกลง & เงื่อนไข",
    dont_have_an_account: "คุณยังไม่ได้เป็นสมาชิก? ",
    membership_details: "รายละเอียดสมาชิก ",
    sign_up_to: "ลงชื่อเข้าใช้งาน",
    sign_in_to: "ลงชื่อเข้าใช้ร้าน",
    choose_sign_up_method: "เลือกช่องทางสมัครสมาชิก ",
    choose_sign_in_method: "เลือกช่องทางลงชื่อเข้าใช้งาน ",
    or: "หรือ",
    forgot: "ลืม",
    password: " รหัสผ่าน?",
    _password: "รหัสผ่าน",
    email: "อีเมล",
    tel: "เบอร์โทร",
    phone: "เบอร์โทร",
    name: "ชื่อ",
    surname: "นามสกุล",
    fullname: "ชื่อ - นามสกุล",
    name_lastname: "ชื่อ - นามสกุล",
    name_surname: "ชื่อ - นามสกุล",
    remember_me: "จดจำฉัน",
    confirm_password: "ยืนยันรหัสผ่าน",
    reset_your_password: "รีเซ็ทรหัสผ่านของคุณ",
    email_recovery_link: "รับอีเมลรีเซ็ทรหัสผ่าน",
    new_password: "รหัสผ่านใหม่",
    confirm_new_password: "ยืนยันรหัสผ่านใหม่",
    sign_up: "ต่อไป",
    already_have_an_account: "คุณเป็นสมาชิกอยู่แล้ว? ",
    sign_in: "ต่อไป",
    please_enter_OTP: "กรุณากรอก OTP",
    submit: "ยืนยัน",
    save: "บันทึก",
    verify_email: "ยืนยันอีเมล",
    verify_phone: "ยืนยันเบอร์โทร",
    resend_OTP: "ส่ง OTP อีกครั้ง",
    fill_in_the_information_and_receive_special_benefits: "กรอกข้อมูลเพื่อรับสิทธิสุดพิเศษ",
    birth_date: "วันเดือนปีเกิด (วว/ดด/ปป)",
    accept_terms_conditions: "ยอมรับ ข้อตกลง & เงื่อนไข",
    sign_up_failed: "สมัครสมาชิกไม่สำเร็จ",
    sign_in_failed: "ลงชื่อเข้าใช้งานไม่สำเร็จ",
    email_password_correct: "อีเมลและรหัสผ่านไม่ถูกต้อง",
    login_successfully: "ลงชื่อเข้าใช้งานสำเร็จ",
    login_failed: "ลงชื่อเข้าใช้งานไม่สำเร็จ",

    history_receipt: "อัปโหลดหลักฐาน",
    upload: "อัปโหลด",
    points: "Points",
    baht: "บาท",
    coupon: "คูปอง",
    coupon_label: "คูปอง",
    coupons: "คูปอง",
    expire_in: "หมดอายุภายใน",
    _month: "เดือน",
    use_point: "ของรางวัล",
    benefits: "สิทธิพิเศษ",
    history: "ประวัติ",

    collected: "เก็บ",
    discount_coupon: "คูปองส่วนลด",
    desc: "ใช้ได้เมื่อซื้อสินค้ามากกว่า 100 บาท",
    expiration_date: "วันหมดอายุ",
    recceive_coupon: "รับคูปอง",
    collect_coupon: "เก็บคูปอง",
    expired: "หมดอายุ",
    freeze: "Freeze",
    coupon_code: "โค้ดคูปอง",
    use_coupon: "ใช้คูปอง",
    BAHT: "บาท",
    percent_sign: "%",
    enter_delivery_address: "Please Enter Delivery Address",
    enter_login_address: "Please Enter Address",
    confirm_address: "Confirm Address",
    address_success: "เพิ่มที่อยู่สำเร็จ",
    // coupon: {
    //     collected: "เก็บ",
    //     discount_coupon: "คูปองส่วนลด",
    //     desc: "ใช้ได้เมื่อซื้อสินค้ามากกว่า 100 บาท",
    //     expiration_date: "วันหมดอายุ",
    //     recceive_coupon: "รับ คูปอง",
    //     collect_coupon: "เก็บ คูปอง ",
    //     coupon_code: "โค้ด Coupon",
    //     use_coupon: "ช้ coupon",
    // },
    quantity_available: "รายการนี้มี({{number}} จำนวนทั้งหมดเหลืออยู่)",
    have_points_left: "คุณจะเหลือ {{number}} Points",
    select_type: "เลือกประเภท",
    descriptions: "รายละเอียด",
    _point: "point",

    MEMBER: "สมาชิก {{text}}",
    use_points: "ใช้ Points",
    do_not_have_enough_points: "คุณมีคะแนนไม่เพียงพอ",
    description: "รายละเอียด",
    collect_benefit: "เก็บสิทธิพิเศษ",

    done: "เสร็จสิ้น",
    transaction: "รายการแลกเปลี่ยน",
    coupon_title: "คูปอง{{number}} ถูกส่งแล้ว",

    used: "เคลมแล้ว",

    point: "คะแนน",
    earned: "ได้รับ",
    reward: "ของรางวัล",
    benefit: "สิทธิพิเศษ",
    confirmation: "การยืนยัน",
    confirmation_slip: "รายการยืนยัน",

    item: "รายการ",
    ticket: "เลขทำรายการ",
    date_time: "วันที่ / เวลา",
    type: "ประเภท",
    confirm: "ยืนยัน",
    desConfirm: "กรุณาแสดงหน้าจอนี้หรือแคปเจอร์เก็บไว้ และ นำไปแสดงหลักฐานให้กับร้านค้า",

    welcome: "ยินดีต้อนรับ!",
    become_welcome: "สมัครสมาชิก",
    desc_welcome: "เพื่อรับสิทธิสุดพิเศษ!",
    become: "เข้าสู่ระบบ/สมัครสมาชิก",
    qrCode: "QR Code",
    qrCode_thai: "ของฉัน",
    my_qr_title: "QR Code ของฉัน",

    member_id: "เลขสมาชิก",
    seller_id: "เลขพนักงานขาย",

    request_connect_link: "ต้องการเชื่อมต่อบัญชีกับ LINE",
    link_line: "เชื่อมต่อบัญชี LINE",
    become_member: "ต้องการเป็นสมาชิก",
    fill_in_your_information: "กรุณากรอกข้อมูลของคุณเพื่อเป็นสมาชิก ",
    _and_receive: " เพื่อรับสิทธิสุดพิเศษดังนี้",
    star_desc: "สะสมคะแนนเพื่อนำไปแลกของรางวัล",
    coupon_desc: "รับคูปอง",
    benefit_desc: "ฟรีสิทธิพิเศษสำหรับสมาชิก",
    draws_desc: "ร่วมลุ้นชิงโชค",
    rules_of_points: "กฎการสะสมคะแนน",
    _baht_spent: "บาท",
    _baht: "บาท",

    phone_number: "เบอร์โทร",

    date: "วันที่",
    date_of_birth: "วันเดือนปีเกิด",
    link_different: "เชื่อมต่อบัญชี LINE",
    request_link: "ต้องการเชื่อมต่อบัญชีกับ LINE",
    _of: "จาก",
    _to_level: "ถึงกลุ่มสมาชิก {{rank}}",
    _level: "กลุ่มสมาชิก",

    member_ShipTier: "กลุ่มสมาชิก",

    member_shipTier_desc: "ปลดล็อคสิทธิสุดพิเศษในแต่ละกลุ่มสมาชิก!",
    earn_points_in_a_year: "สะสม",
    _member: "สมาชิก",
    _spent: " ยอดใช้งาน",
    earn: "ได้รับ ",
    upgrade: "อัปเกรดเป็น",

    point_given: "Point ที่ได้รับ",

    use_free_point: "ใช้ Free Point",
    collect_free_points: "รับ Free Points",

    phone_desc: "เราได้ส่งโค้ด OTP ไปยังโทรศัพท์คุณ ",
    email_desc: "เราได้ส่งโค้ดยืนยันไปยังอีเมลคุณ",
    enter_it_here: "กรอกโค้ดของคุณที่นี่",
    resend_otp: "ส่ง OTP อีกครั้ง",
    resend_code: "ส่งโค้ดอีกครั้ง",

    goback_home: "Lavish",
    back: "ย้อนกลับ",
    select: "เลือก",
    increase: "เพิ่ม",
    decrease: "ลด",
    add_points_from_shop: "ได้รับ Points จากร้าน: {{points}} points ",
    sub_points_from_shop: "Points ถูกหักจากร้าน: {{points}} points",
    redeem_reward: "แลกรับของรางวัล",
    redeem_benefit: "รับสิทธิพิเศษ",
    please_sign_up_to_collect_free_point: "กรุณาสมัครสมาชิกเพื่อสะสม Free Proints",
    please_sign_up_to_collect_coupon: "กรุณาสมัครสมาชิกเพื่อสะสมคูปอง",
    lang_en: "EN",
    lang_th: "TH",
    en: "English",
    th: "ภาษาไทย",
    no_coupon: "บัญชีของท่านยังไม่ได้รับคูปอง",
    no_benefit: "บัญชีของท่านยังไม่มีสิทธิพิเศษ",
    no_point: "บัญชีของท่านยังไม่มีของรางวัล",
    no_history: "ยังไม่มีประวัติการทำรายการ",
    confirm_lable_note:
        "Please show this screen or capture this screen and present them to the merchant",
    data_privacy: "ยินยอมให้ใช้ข้อมูลเพื่อทำการตลาด",
    consent_marketing_purpose: "เราใส่ใจความเป็นส่วนตัวของคุณอยู่เสมอ",
    we_always_care_about_your_privacy:
        "คุณสามารถเรียนรู้คำชี้แจงนโยบายการเก็บ รวบรวม และใช้ข้อมูลส่วนบุคคลได้ที่ นโยบาลความเป็นส่วนตัวข้อมูลของคุณจะถูกนำไปใช้เพื่อการโฆษณา และ การตลาด เพื่อประโยชน์ในการได้รับสินค้าหรือบริการของเรา เราใช้ข้อมูลของคุณเพื่อวิเคราะห์และปรับปรุงสินค้าหรือบริการ และ ทำการตลาดผ่าน Google, Facebook, pixel tracking code และอื่น ๆ เราใช้ข้อมุลดังกล่าวเพื่อให้สินค้าหรือบริการเหมาะสมกับคุณ,",
    how_we_collect:
        "เราอาจะส่งข้อมูลหรือจดหมายข่าวไปยังอีเมลของคุณ โดยมีวัตถุประสงค์เพื่อเสนอสิ่งที่น่าสนใจกับคุณ หากคุณไม่ต้องการรับกาาติดต่อสื่อสารจากเราผ่านทางอีเมลหรือช่องทางอื่น ๆ อีกต่อไป คุณสามารถติดต่อเราผ่าน Call Center ที่แจ้งด้านล่าง",
    research_anaylze:
        "หากคุณกดยินยอม หมายความ ว่าคุณยินยอมให้เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณ และ ให้เรานำข้อมูลของคุณไปใช้เพื่อการตลาดที่ระบุไว้ข้างต้น",
    you_agree_let_us:
        "ายใต้กฎหมายคุ้มครองข้อมลู ส่วนบุคคลคุณมีสิทธิในการดําเนินการขอถอนความยินยอม หากคุณได้ยินยอมให้เราเก็บรวบรวมใช้หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ สามารถถอนความยินยอมได้ตลอดเวลา โดยแจ้งการถอนความยินยอมได้ที่ Rocket Digital Call Center เบอร์โทรติดต่อ: 021159646 (รายละเอียดถอนความยินยอมเพิ่มเติมกรุณาตรวจสอบรายละเอียดที่ Privacy Notice)",
    right_to_withdraw_this_consent: "",
    please_further_read_our_Privacy:
        "บริษัทจะดำเนินการรับคำขอถอนความยินยอมภายใน 7 วันทำการ (จันทร์ - ศุกร์) และจะใช้เวลาประมาณ 30 วันทำการ เพื่อดำเนินการถอนความยินยอม",
    if_you_do_not_give_consent:
        "การถอนความยินยอมอาจทำให้คุณพลาดโอกาสในการรับข้อเสนอผลิตภัณฑ์ บริการ และสิทธิพิเศษที่เหมาะสมกับความต้องการของคุณได้",
    terms_conditons: "ข้อกำหนดและเงื่อนไข",
    allow_for: "ยินยอมแบบฟอร์ม",
    logout: "ออกจากระบบ",
    pls_answer_questions: "Please answer questions",
    pls_answer_address: "Please answer address",
    use: "Use",
    active: "Active",
    gender: "เพศ",
    you_should_fill_dateofbirth_field: "You should answer Date of birth field",
    you_should_fill_email_field: "You should answer email field",
    you_should_fill_gender_field: "You should answer gender field",
    redemption_code: "Redemption Code:",
    additional_information_questionnaire: "แบบสอบถามข้อมูลเพิ่มเติม",
    please_enter_the_details_above: "กรุณากรอกรายละเอียดข้างต้น",
    login_sign_up: "เข้าสู่ระบบ",
    to_store: "{{name}}",
    enter_your_phone_number: "กรุณาใส่หมายเลขโทรศัพท์",
    please_proceed_with_LINE: "ดำเนินการต่อด้วย LINE",
    please_enter_OTP_from_your_SMS: "กรุณากรอกหมายเลข OTP",
    edit: "แก้ไข",
    send_otp: "รับรหัส OTP",
    next: "ถัดไป",
    phone_number_placeholder: "หมายเลขโทรศัพท์",
    details_menu: "Details Menu",
    my_order: "My Order",
    uploadActivity: {
        title: "อัปโหลดกิจกรรม",
        description: "กรุณาอัปโหลดกิจกรรมเพื่อสะสมคะแนน คุณจะได้รับคะแนนภายใน 24 ชม.",
        selectTypeLabel: "ประเภทกิจกรรม",
        uploadLabel: "+ กดเพื่ออัปโหลดกิจกรรม",
        viewExampleBtn: "ดูตัวอย่างรูปภาพกิจกรรม",
        sendActivityBtn: "ส่งกิจกรรม",
        selectActivityPlaceholder: "เลือกกิจกรรม",
        example: {
            title: "ดูตัวอย่างรูปถ่าย",
            description: "ถ่ายภาพหลักฐานเพื่อสะสมแต้มทันที",
        },
        success: {
            title: "อัปโหลดกิจกรรมสำเร็จ!",
            description: "คุณจะได้รับคะแนนภายใน 24 ชม.",
        },
        error: {
            selectActivity: "กรุณาเลือกกิจกรรม",
            emptyError: "กรุณาอัปโหลดรูปภาพ",
        },
    },
    upload_receipt: {
        title: "อัปโหลดคะแนน",
        upload_text: " อัปโหลด ",
        receipt: "หลักฐาน",
        view_example: "ดูตัวอย่างใบเสร็จ",
        view_receipt_example: "ดูตัวอย่างใบเสร็จ",
        example: "Example Receipt",
        empty_error: "กรุณาอัปโหลดรูปภาพ",
        success: "อัปโหลดสำเร็จ",
        to_seller: "พนักงานขายที่แนะนำ",
        seller_title: "พนักงานขายที่แนะนำ",
        select_img: "เลือกรูปภาพ",
        scarn_img: "สแกนรหัส PC QR",
        send_receipt: "ส่งใบเสร็จ",
        seller_id: "รหัสพนักงานขาย",
        success_with_text: "อัปโหลด {{text}} สำเร็จ",
        upload_failed: "อัปโหลดใบเสร็จไม่สำเร็จ",
        success_notice: "คะแนนของท่านจะได้รับภายใน {{days}} วัน",
    },
    note: "note",
    card: {
        giftCard: "Gift Card",
        title: "Member Cards",
        add_gift_card: "Add Gift Card",
        input_card_num: "gift card",
        input_card_ser: "Serial number",
        place_card_num: "กรุณากรอกหมายเลขการ์ด",
        place_card_ser: "กรอกหมายเลข serial number",
        add_card: "เพิ่มการ์ด",
        link_card: "Link Card",
        phy_card_num: "Physical member card",
        phy_card_ser: "Serial number",
        select_member: "เลือกประเภทสมาชิก",
        unlink_role:
            "เมื่อคุณยกเลิกการเชื่อมโยงบัตรสมาชิกของคุณแล้ว คุณจะไม่สามารถใช้งานมันได้อีกต่อไป แทนที่นั้น จะใช้บัตรสมาชิกออนไลน์ที่มีอยู่ของคุณแทน",
        unlink_title: "คุณต้องการยกเลิกการเชื่อมต่อบัตรหรือไม่",
        add_money: "เติมเงิน",
        transaction_history: "ประวัติการใช้งาน",
        setting_card: "ตั้งค่าบัตร",
        link_physical_card: "เชื่อมต่อบัตรแข็ง",
        online_member_card: "บัตรสมาชิกออนไลน์",
        top_up: "จ่ายเงินและเติมเงิน",
        select_channel_payment: "เลือกช่องทางการชําระเงิน",
        online_payment: "ชําระออนไลน์",
        store_payment: "ชําระที่หน้าร้านสาขา",
        enter_amount: "ยอดเงินที่ต้องการเติม",
        thb: "บาท",
        used: "การใช้งาน",
        time: "ครั้ง",
    },
    mem_type: {
        create_title: "สมัครสมาชิก ประเภทนักเรียน",
        verify_title: "อัปโหลดหลักฐาน",
        success: "create succress",
        regis_btn: "สมัครเลย",
        bene_for: "สิทธิพิเศษ สำหรับ",
        bene: "สิทธิพิเศษ",
        for: "สำหรับ",
        employee: "พนักงาน",
        upload_suscess: "อัปโหลดหลักฐานสำเร็จ",
        please_wait: "กรุณารอการอนุมัติ",
    },
    top_charoen_terms_title: "เงื่อนไขการร่วมรายการ",
    please_confirm_your_phone_number: "กรุณายืนยันหมายเลขโทรศัพท์ของคุณ",
    cancel: "ยกเลิก",
    address: "ที่อยู่",
    conditions: "รายละเอียดและเงื่อนไข",
    redeem: "แลกสิทธิ์",
    view: "ดูเพิ่มเติม",
    setting: "ตั้งค่า",
    myprofile: "โปรไฟล์",
    claimcoupon: "เก็บคูปอง",
    couponcode: "Coupon Code",
    rewardCode: "Reward Code",
    benefitCode: "Benefit Code",
    member_type: {
        pre_title: "เลือกประเภทสมาชิก",
    },
    close: "ปิด",
    pending: "รอดำเนินการ",
    approve: "อนุมัติแล้ว",
    reject: "ถูกปฏิเสธ",
    history_redeem: {
        title: "ประวัติการใช้งาน",
        tab_point: "คะแนน",
        tab_redemp: "การแลกสิทธิ์",
        tab_upload: "การอัปโหลด",
        gain_point: "รับคะแนน",
        use_point: "ใช้คะแนน",
        gain: "เก็บ",
        use: "ใช้",
        upload: "อัพโหลด",
        COUPON: "คูปอง",
        REWARD: "ของรางวัล",
        BENEFIT: "สิทธิพิเศษ",
        ACTIVE: "ใช้สิทธิ์แล้ว",
        PENDING: "ยังไม่ใช้สิทธิ์",
        undefined: "ยังไม่ใช้สิทธิ์",
        RESOLVED: "ใช้สิทธิ์แล้ว",
        REDEEMED: "ยังไม่ใช้สิทธิ์",
        RECEIVED: "รับสิทธิ์แล้ว",
        REDEEMED_next: "ใช้สิทธิ์",
        RECEIVED_next: "Redeem",
        RESOLVED_next: "ใช้สิทธิ์แล้ว",
        PENDING_next: "ใช้สิทธิ์",
        undefined_next: "ใช้สิทธิ์",
        expired: "หมดอายุ",
        points: "คะแนน",
        LUCKYDRAW: "ชิงโชค",
        MISSION: "ภารกิจ",
        redeem_date: "วันที่ใช้สิทธิ์",
        exp_date: "หมดอายุ",
        useDate: "วันที่ใช้งาน",
        REPLACED: "ปรับปรุงคะแนน",
        reverse_point: "Reverse point",
        cancel_receipt: "Cancel",
        remark: "หมายเหตุ",
    },
    invitefriendtoget: "ชวนเพื่อนสมัครสมาชิก รับ 50 คะแนน",
    invitemembertoget: "ชวนเพื่อนสมัครสมาชิก รับ 50 คะแนน",
    pleasecopyinvitefriend:
        "คัดลอกลิงค์หรือแชร์ QR code ให้เพื่อน รับคะแนนเมื่อเพื่อนซื้อสินค้าครั้งแรก",
    pleasecopyinvitemember:
        "คัดลอกลิงค์หรือแชร์ QR code ให้เพื่อน รับคะแนนเมื่อเพื่อนซื้อสินค้าครั้งแรก",
    invitefriend: {
        friend_sign_title: "คัดลอกลิงค์หรือแชร์ QR code ให้เพื่อน",
        friend_sign_desc: "รับคะแนนเมื่อเพื่อนลงทะเบียนเข้าใช้งาน",
        friend_collect_title: "คัดลอกลิงค์หรือแชร์ QR code ให้เพื่อน",
        friend_collect_desc: "รับคะแนนเมื่อเพื่อนซื้อสินค้าครั้งแรก",
        seller_sign_title: "คัดลอกลิงค์หรือแชร์ QR code ให้เพื่อน",
        seller_sign_desc: "รับคะแนนเมื่อเพื่อนลงทะเบียนเข้าใช้งาน",
        seller_collect_title: "คัดลอกลิงค์หรือแชร์ QR code ให้เพื่อน",
        seller_collect_desc: "รับคะแนนเมื่อเพื่อนซื้อสินค้าครั้งแรก",
    },
    copy: "คัดลอก",
    sharelink: "แชร์ลิงค์สมัครสมาชิก",
    sharelinkMember: "แชร์ลิงค์สมัครสมาชิก",
    pretype: {
        email: "อีเมล",
        gender: "เพศ",
        dateOfBirth: "วันเดือนปีเกิด",
        address: "ที่อยู่",
        id_card: "เลขบัตรประชาชน",
        companyName: "ชื่อบริษัท",
        studentID: "เลขนักเรียน",
        staffID: "เลขพนักงาน",
        channelStore: "ร้านค้า",
        channelId: "Channel ID",
        storeId: "Store ID",
        staffArea: "พื้นที่ทำการ",
    },
    province: "จังหวัด",
    county: "เขต",
    district: "ตำบล",
    zipcode: "รหัสไปรษณีย์",
    createaccount: "สร้างบัญชี",
    pleaseconfirm: "โปรดยืนยันการแลกสิทธิ์",
    detail: "รายละเอียด",
    campaignperiod: "ระยะเวลาแคมเปญ",
    participate: "เข้าร่วม",
    luckydraw: "กิจกรรมชิงโชค",
    desLuckydraw: "คุณได้เข้าร่วมกิจกรรมชิงโชคสำเร็จ โปรดรอผลประกาศ",
    for_new_member_only: "สำหรับสมาชิคใหม่เท่านั้น",
    day: "วัน",
    month: "เดือน",
    year: "ปีเกิด",
    update_email_success: "อัปเดทข้อมูลส่วนตัวสำเร็จ!",
    congratulation: "ขอแสดงความยินดี !",
    youget: "คุณได้รับ",
    survey_submit_success_no_point: "ขอบคุณสำหรับการตอบแบบสำรวจ ข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
    claimreward: "เคลมรางวัล",
    MALE: "ชาย",
    FEMALE: "หญิง",
    NOT_SPECIFIED: "ไม่ระบุ",
    leaderboard_disabled: "รายการจัดอันดับนี้ได้ปิดใช้บริการแล้ว",
    waiting_rank: "ระบบกำลังคำนวณอันดับ...",
    cardId: "เลขบัตรประชาชน",
    dataNotFound: "ไม่พบข้อมูล",
    verify: "ตรวจสอบ",
    get_otp: "รับรหัส OTP",
    resend: "ส่งอีกครั้ง",
    all_fields_are_required: "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    staffArea: "พื้นที่ทำการ",
    paymentProcessing: "ระบบกำลังนำท่านสู่หน้าจอเติมเงิน",
    selectmembergroup: "เลือกประเภทกลุ่มสมาชิก",
    line_login: "เข้าสู่ระบบด้วย LINE*",
    line_login_subtitle: "โปรดเข้าสู่ระบบด้วย LINE *",
    giftcard: "บัตรของขวัญ",
    login: "เข้าสู่ระบบ",
    uploadReceipt: "อัปโหลดหลักฐานที่นี่",
    usage: "การใช้งาน",
    sign_up_now_get: "สมัครสมาชิกเพื่อรับ",
    welcome_to: "ยินดีต้อนรับสู่",
    transactionhistory: "ประวัติการใช้งาน",
    settingcard: "ตั้งค่าบัตร",
    removecard: "ลบบัตร",
    usageamount: "ยอดเงินที่ใช้ได้",
    usegiftcard: "ใช้บัตรของขวัญ",
    pleaseselectamounttouse: "จำนวนครั้งที่ใช้ได้",
    thb: "บาท",
    enterordernumberhere: "กรอกเลขออเดอร์ของคุณ",
    claimorderid: "รายการออเดอร์ที่รับคะแนนได้",
    nodatafound: "ไม่พบรายการสั่งซื้อจากช่องทางอื่น",
    saleAmount: "ยอดซื้อ",
    claim: "รับคะแนน",
    areyousure: "คุณแน่ใจที่จะรับคะแนนสำหรับคำสั่งซื้อนี้หรือไม่?",
    onceclaimed: "เมื่อรับแล้ว คุณจะไม่สามารถคืนสินค้าได้",
    campaign: {
        details: "รายละเอียด",
        joinnow: "เข้าร่วมเลย !",
        leaderboard: "กระดานจัดอันดับ",
        stats: "สถิติ",
        ranking: "อันดับ",
        timeupload: "อัปโหลด",
        totalpointscollected: "คะแนนสะสม",
        total: "ทั้งหมด",
        pending: "รอดำเนินการ",
        approve: "อนุมัติ",
        reject: "ปฏิเสธ",
        nodata: "ไม่มีข้อมูล",
        uploadactivity: "อัปโหลดกิจกรรม",
        uploadactivitypoint: "อัปโหลดกิจกรรมเพื่อสะสมคะแนน",
    },
    // claimfalse: "สถานะออร์เดอร์ของคุณไม่สามารถรับคะแนนได้",
    claimfalse:
        "หากสถานะเป็น ‘จัดส่งสำเร็จ' หรือ 'สำเร็จ’ แต่ยังไม่สามารถรับคะแนนได้ กรุณาลองอีกครั้งในวันถัดไป",
    pleasEnterOrder: "กรุณากรอกเลขออเดอร์",
    orderNotFound: "ไม่พบออเดอร์ในระบบ",
    claimSuccess: "คุณได้เคลมคะแนนสำเร็จแล้ว",
    youDelivery: "ของรางวัลของคุณจะถูกจัดส่งไปตามที่อยู่ด้านล่างนี้",
    exp: "ใช้ได้",
    pleaseSelect: "กรุณาเลือก",
    display_profile_pointLessZero: "Tier ของคุณจะอัปเดตเร็วๆ นี้",
};
